import {MegaScreen} from './MegaScreen.js';
import {PostMessages} from './PostMessages.js';
import {notNil} from '@megaphonenpm/mputils/src/utils.js';

export class AudioManager {
  /**
   * @param view The main application View instance.
   */
  constructor (view) {
    this.view = view;
    this.muted = null;
    this.disabled = false;
    MegaScreen.globals.mousetrap.bind('m', this.toggleMute.bind(this));
  }

  /**
   * Mutes or unmutes all sounds in MegaScreen, and sends MegaScreen's current mute status to
   * MegaScreen's parent application (e.g., Director).
   *
   * @param muted
   */
  setMuted (muted) {
    if (!this.disabled && muted !== this.muted) {
      this.muted = muted === true;

      this.view.runviews.forEach(runview => {
        if (runview.valid && notNil(runview.sceneMediaContainer)) {
          runview.sceneMediaContainer.setMuted(this.muted);
        }
      });

      this.view.mediaviews.forEach(mediaview => {
        mediaview.setMuted(this.muted);
      });

      this.dispatchMutedState();
    }
  }

  /**
   * When disabled is true, MegaScreen will reject all attempts to unmute sound.
   */
  setDisabled (disabled) {
    if (disabled === true) {
      // Turn off "disabled mode" to allow use of setMuted()
      this.disabled = false;
      // Mute application
      this.setMuted(true);
      // Turn on "disabled mode"
      this.disabled = true;
    } else {
      // Turn off "disabled mode" (but leave current mute state untouched)
      this.disabled = false;
    }
  }

  /**
   * Initialize state of all audio in MegaScreen.
   */
  init () {
    let muteQueryStringParam = new URLSearchParams(window.location.search).get('mute');
    if (muteQueryStringParam === 'true') {
      this.setMuted(true);
      this.setDisabled(true);
    } else {
      this.setMuted(false);
    }
  }

  toggleMute () {
    this.setMuted(!this.muted);
  }

  dispatchMutedState () {
    MegaScreen.globals.postMessageManager.send(this.muted
      ? PostMessages.MEGASCREEN_MUTED
      : PostMessages.MEGASCREEN_UNMUTED);
  }
}
